import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: 16,
    backgroundColor: theme.palette.background.default
  },
  historyText: {
    color: theme.palette.grey[700],
    fontWeight: 600,
    '& span': {
      color: theme.palette.grey[500],
      fontWeight: 400
    }
  },
  rowContainer: {
    marginTop: 10,
    backgroundColor: theme.palette.background.paper,
    padding: '10px 20px',
    height: 72
  },
  outerContainer: {
    display: 'flex'
  },
  leftLine: {
    backgroundColor: theme.palette.grey[300],
    width: 1,
    marginLeft: 15,
    marginRight: 25,
    marginTop: 10,

    height: 85
  },
  lastIndexLeftLind: {
    backgroundColor: theme.palette.background.default,
    width: 1,
    marginLeft: 15,
    marginRight: 25,
    marginTop: 10,
    height: 72
  },

  iconWrapper: {
    fontSize: 16,
    marginRight: theme.spacing(2),
    width: 30,
    height: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: `2px solid ${theme.palette.divider}`
  },
  allocateIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#e8f5e9',
    color: '#4caf50',
    borderColor: '#4caf50'
  },
  deallocateIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#fff8e1',
    color: '#ffc107',
    borderColor: '#ffc107'
  },
  reserveIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#e3f2fd',
    color: '#2196f3',
    borderColor: '#2196f3'
  },
  cancelIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#ffebee',
    color: '#f44336',
    borderColor: '#f44336'
  },
  modifyIcon: {
    '& svg': {
      fontSize: 16
    },
    backgroundColor: '#f5f5f5',
    color: '#9e9e9e',
    borderColor: '#9e9e9e'
  },
  detailsButton: {
    color: theme.palette.primary.main
  },
  requestLink: {
    color: theme.palette.info.main,
    textDecoration: 'none',
    fontWeight: 'bold'
  },
  successStatus: {
    color: theme.palette.success.main,
    fontWeight: 'bold'
  },
  rowItem: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default useStyles
